import React from 'react';
import './App.css';
import logos from './logos.svg';
import users from './users.svg';
import firebase from "firebase/app";
import { Component, createContext, useState, useEffect, useContext, useCallback }  from 'react';
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";
import slide_2 from './images/slide_2.png';
import raphael from './raphael.jpg';
import slide_3 from './images/slide_3.png';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Sketchpad from './Sketchpad.png';
import status from './status.png';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Button from '@material-ui/core/Button';
import { Link, Router } from "@reach/router";
import TextField from '@material-ui/core/TextField';
import { PaystackButton } from "react-paystack";
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';







export default function AddStatuses (props) {


  

    const user = firebase.auth().currentUser;

const {display, setDisplay} = useState('none');





const allInputs = {imgUrl: ''};
    const [imageAsFile, setImageAsFile] = useState('');
    const [imageAsUrl, setImageAsUrl] = useState(allInputs);
    const [media, setMedia] = useState(null);
    const [fileType, setFileType] = useState('');

const [uploadArray, setUploadArray] = useState([]);


 function handleImageAsFile (e) {
      const image = e.target.files[0]
      setImageAsFile(imageFile => (image));
      setMedia(image);
     setFileType(image.type);

  }
  console.log('reloading');


function AddInfo (props) {


const displayName = props.displayName;
const displayPicture = props.displayPicture;  
const userProfile = props.userProfile;
const postCount = props.postCount;
const location = props.location;
const school = props.school;


  

const [uploaded, setUploaded] = useState(false);
const currentTime = new Date().getTime();
const [disabled, setDisabled] = useState(false);
const [loadingDescription, setLoadingDescription] = useState('');

async function uploadTexts () {

   setLoadingDescription('loading of setMedia to database is ongoing, do not cancel');
     setDisabled(true);
  

      
 setLoadingDescription('now its time to upload the texts, should be done soon');
   await firebase.firestore().collection('StudentStatus').doc(`${currentTime}`).set({
    displayName: displayName,
    avatar: displayPicture,
    createdAt: currentTime,
    Title: title,
    Description: description,
    Link: link,
    linkCaption: linkCaption,
    MediaType: fileType,
    Occ: !school ? userProfile : school,
    time: currentTime,
   
    // ...
  });

     
  

await firebase.database()
.ref('/User/' + user.uid )
.update({
  
postCount : !postCount ? 1 : postCount + 1 ,
    
   
  
});

     setLoadingDescription('check the daily status page, you should see your post there');

setPaymentStatus('not paid');

}

    async function uploadStatus () {
     
     setLoadingDescription('loading of setMedia to database is ongoing, do not cancel');
     setDisabled(true);
      await firebase.storage().ref('/Status/Business/' + user.uid + `/${postCount}/` ).put(imageAsFile).then(function(snapshot) {
  console.log('Uploaded a blob or file!');
       setLoadingDescription('loading of image to database is ongoing, do not cancel');

  
});

      
 setLoadingDescription('now its time to upload the texts, should be done soon');
        await  firebase.storage().ref('/Status/Business/' + user.uid + `/${postCount}/`).getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);
   firebase.firestore().collection('StudentStatus').doc(`${currentTime}`).set({
    displayName: displayName,
    Image: downloadURL,
    avatar: displayPicture,
    createdAt: currentTime,
    Title: title,
    Description: description,
    Link: link,
    linkCaption: linkCaption,
    MediaType: fileType,
    Occ: !school ? userProfile : school,
    time: currentTime,
   
    // ...
  });

     
  
  

 firebase.database()
.ref('/User/' + user.uid )
.update({
  
postCount : !postCount ? 1 : postCount + 1 ,
    
   
  
});


     setLoadingDescription('check the daily status page, you should see your post there');

setPaymentStatus('not paid');
  });
    
    }

    const amount = 100000;
    const [email, setEmail] = useState("");
    const [name, setName] = useState(""); 
    const [phone, setPhone] = useState("");




const config = {
  public_key: 'FLWPUBK_TEST-7e2f3de2121dc2429f49d0c8916237c5-X',
  tx_ref: Date.now(),
  amount: 1000,
  currency: 'NGN',
  payment_options: 'card,mobilemoney,ussd',
  customer: {
    email: user.email,
    phonenumber: phone,
    name: displayName,
  },
  customizations: {
    title: 'Business status',
    description: 'Payment for status upload',
    logo: 'https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg',
  },
};

const handleFlutterPayment = useFlutterwave(config);







const [paymentStatus, setPaymentStatus] = useState('not paid');

const publicKey = "pk_test_6ae7e399bc17e2625741ed18b1a088007ba46134";






  const componentProps = {
    email,
    amount,
    metadata: {
      name,
      phone,
    },
    publicKey,
    text: "Pay Now",
    onSuccess: () => {setPaymentStatus('paid')},
    onClose: () =>  <p> payment not successfull </p>
  }



const [title, setTitle] = useState('');
const [description, setDescription] = useState('');
const [link, setLink] = useState('');
const [linkCaption, setLinkCaption] = useState('');


    return (
<div style={{display: 'flex', flexDirection: 'column'}} >

<p>{props.displayName}</p>

  <TextField
          
          label="Status Title"
          type="text"
         
          variant="outlined"
          placeholder='use a catchy title'
          required
          value = {title}
          autoFocus
         onChange={(e) => setTitle(e.target.value)}
        /> 

        <TextField
          id="outlined-Description"
          label="Status Description"
          type="text"
         
          variant="outlined"
          placeholder='Choose your words like a business person'
          required
          value = {description}
         onChange={(e) => setDescription(e.target.value)}
          multiline
          fullWidth
        />

          <TextField
          id="outlined-LinkCaption"
          label="Link Caption"
          type="text"
         
          variant="outlined"
          placeholder='Link Caption'
          required
          value = {linkCaption}
         onChange={(e) => setLinkCaption(e.target.value)}
          
        />

          <TextField
          id="outlined-link"
          label="Link"
          type="text"
          variant="outlined"
          placeholder='Fill in your Link'
          required
          value = {link}
         onChange={(e) => setLink(e.target.value)}
          multiline
          fullWidth
        />

<img src={media? URL.createObjectURL(media) : null} alt={media? media.name : null}/>      
         <label className="btn btn-default">
        <input type="file"  onChange={handleImageAsFile}             accept="image/png, image/gif, image/jpeg, video/mp4, video/3gp"
/>
      </label>


     

         
            
            <label>Phone</label>
            <input
              type="text"
              id="phone"
              onChange={(e) => setPhone(e.target.value)}
            />



<p>To keep the status a serious matter, we have made sure that you need to pay before adding a status</p> 
<h3> hnce, click the pay now button to see the upload button</h3>
<PaystackButton {...componentProps} />

<Button
        onClick={() => {
          handleFlutterPayment({
            callback: (response) => {
               console.log(response);
               setPaymentStatus('paid');
                closePaymentModal() // this will close the modal programmatically
            },
            onClose: () => <p> payment not successfull </p>,
          });
        }}
      >
        Payment with React hooks
      </Button>


{paymentStatus == 'paid' ?  <div> <Button
        variant="contained"
        color="primary"
        onClick={ !imageAsFile ? uploadTexts : uploadStatus}
        disabled={disabled}
      >Upload</Button>
      <p>{loadingDescription}</p>
      <p> tap on the button, once it disappears, your status has been uploaded. this is your {postCount} post</p>
      </div> : null }
</div>
      )
   }


return(
<div>
<h3> add your status below </h3>
<div className='addstatus' style={{display: 'flex', flexDirection: 'row' , }}> 
<AddInfo displayName={props.displayName} displayPicture={props.displayPicture} userProfile={props.userProfile} postCount={props.postCount} location={props.location} school={props.school}  />
 </div></div>

)

 	}

   
   